var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-home"},[(_vm.$route.name !== 'basicAllList')?_c('base-head'):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }